export default __webpack_public_path__ + "static/handWater-12ddcd8f086e0135eca3443a30c01215.jpeg";